import _ from 'underscore'
import basicController from 'servicestack/basic.controller.properties'
import $session from 'servicestack/session'
import $appConfig from 'servicestack/config'
import templateUrl from 'emun.salesrep/market-dashboard.htm'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import salesrepConfig from 'emun.salesrep/salesrep.config'

class MarketDashboardController  {
    constructor(createAutoQuery, $session, $window, $state) {
        basicController(this)
        let $ctrl = this;
        $ctrl.salesrepConfig = salesrepConfig;
    }
}

let MarketDashboard = {
    bindings: {
        market: '<',
    },
	controller: MarketDashboardController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default MarketDashboard